/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Overall_ScoreInputs */

const en_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const de_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const fr_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const es_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const it_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const nl_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const pl_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const fi_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const da_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

const sv_deep_match_overall_score = /** @type {(inputs: Deep_Match_Overall_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall Match Score`)
};

/**
* | output |
* | --- |
* | "Overall Match Score" |
*
* @param {Deep_Match_Overall_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_overall_score = /** @type {((inputs?: Deep_Match_Overall_ScoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Overall_ScoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_overall_score(inputs)
	if (locale === "fr") return fr_deep_match_overall_score(inputs)
	if (locale === "es") return es_deep_match_overall_score(inputs)
	if (locale === "it") return it_deep_match_overall_score(inputs)
	if (locale === "nl") return nl_deep_match_overall_score(inputs)
	if (locale === "pl") return pl_deep_match_overall_score(inputs)
	if (locale === "fi") return fi_deep_match_overall_score(inputs)
	if (locale === "da") return da_deep_match_overall_score(inputs)
	if (locale === "sv") return sv_deep_match_overall_score(inputs)
	return en_deep_match_overall_score(inputs)
});